import Layout from '@/layout';

export default {
  path: '/analysis',
  redirect: '/analysis/survey',
  component: Layout,
  meta: {
    title: '数据分析',
    icon: 'iconfont icon-analysis',
    code: '010206'
  },
  children: [
    {
      path: 'survey',
      name: 'Survey',
      component: () => import('@/views/dataAnalysis/survey'),
      props: true,
      meta: {
        title: '本底调查',
        icon: 'iconfont icon-survey',
        code: '01020601'
      }
    },
    {
      path: 'monitor',
      name: 'monitor',
      component: () => import('@/views/dataAnalysis/monitoring'),
      props: true,
      meta: {
        title: '监测分析',
        icon: 'iconfont icon-monitoring',
        code: '01020602'
      }
    },
    {
      path: 'spread',
      name: 'spread',
      component: () => import('@/views/dataAnalysis/spread'),
      props: true,
      meta: {
        title: '报警模型分析',
        icon: 'iconfont icon-alarm-analysis',
        code: '01020603'
      }
    },
    {
      path: 'safetyStatis',
      name: 'safetyStatis',
      component: () => import('@/views/dataAnalysis/safety'),
      props: true,
      meta: {
        title: '安全监测分析',
        icon: 'iconfont icon-safe-analysis',
        code: '01020604'
      }
    },
    {
      path: 'dataExport',
      name: 'dataExport',
      component: () => import('@/views/dataAnalysis/data-search/index'),
      props: true,
      meta: {
        title: '数据导出',
        icon: 'iconfont icon-data-export',
        code: '01020605'
      }
    }
  ]
};
